import { render, staticRenderFns } from "./PaymentMethodCatalog.vue?vue&type=template&id=5734d9a8"
import script from "./PaymentMethodCatalog.vue?vue&type=script&lang=js"
export * from "./PaymentMethodCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5734d9a8')) {
      api.createRecord('5734d9a8', component.options)
    } else {
      api.reload('5734d9a8', component.options)
    }
    module.hot.accept("./PaymentMethodCatalog.vue?vue&type=template&id=5734d9a8", function () {
      api.rerender('5734d9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/PaymentMethodCatalog.vue"
export default component.exports